module.exports = __webpack_public_path__ + "static/media/skf-logo-white.9912e898.svg";